import { faCaretLeft, faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createElement } from "react";
import DatePicker from "react-datepicker";

import { CustomButton } from "./CustomButton";

import { Props } from "./interfaces";
import { Container, Button, DatePickerWrapper } from "./styles";

const FilterByYear = ({ year, handleChangeYear, filterColor, withMaxDate = true }: Props) => {
  const maxYear = new Date(year + 1, 0, 1).getFullYear();

  return (
    <Container>
      <Button
        onClick={() => handleChangeYear("decrease")}
        filterColor={filterColor}
        style={{ minWidth: "unset" }}
      >
        <FontAwesomeIcon icon={faCaretLeft} />
      </Button>
      <DatePickerWrapper>
        <DatePicker
          selected={new Date(year, 0, 1)}
          onChange={(year: Date) => handleChangeYear("default", year)}
          customInput={createElement(CustomButton)}
          dateFormat="yyyy"
          showYearPicker
          maxDate={withMaxDate ? new Date() : null}
        />
      </DatePickerWrapper>
      <Button
        onClick={() => handleChangeYear("increase")}
        disabled={year >= maxYear}
        filterColor={filterColor}
        style={{ minWidth: "unset" }}
      >
        <FontAwesomeIcon icon={faCaretRight} />
      </Button>
    </Container>
  );
};

export default FilterByYear;
